import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M4.363 19.637a1.19 1.19 0 0 1-.324-.57 1.357 1.357 0 0 1 0-.648c.053-.216.157-.403.314-.56l5.853-5.864-5.853-5.854a1.107 1.107 0 0 1-.314-.55 1.592 1.592 0 0 1 0-.658 1.19 1.19 0 0 1 .324-.57c.157-.163.344-.271.56-.324.223-.052.442-.052.658 0 .222.053.412.157.57.315l5.851 5.853 5.853-5.853c.157-.158.343-.262.56-.315.215-.052.431-.052.647 0 .216.053.406.164.57.334.163.157.271.344.324.56.059.216.059.432 0 .648a1.166 1.166 0 0 1-.314.56l-5.843 5.854 5.843 5.864c.157.157.261.344.314.56.052.216.052.432 0 .648-.053.216-.16.406-.324.57a1.19 1.19 0 0 1-.57.324 1.356 1.356 0 0 1-.648 0 1.165 1.165 0 0 1-.56-.315l-5.851-5.854-5.853 5.854a1.165 1.165 0 0 1-.56.315 1.396 1.396 0 0 1-.657 0 1.19 1.19 0 0 1-.57-.324Z",
      color: "currentColor"
    }, null, -1)
  ]))]))
}
export default { render: render }